import styled, { keyframes } from 'styled-components';

const Wrapper = styled.div`
  z-index: ${props => (props.isFullScreen ? '100' : 'inherit')};
  background-color: ${props => (props.isFullScreen ? 'rgba(255, 255, 255, 0.5)' : 'transparent')};
  top: ${props => (props.isFullScreen ? '0' : 'inherit')};
  left: ${props => (props.isFullScreen ? '0' : 'inherit')};
  position: ${props => (props.isFullScreen ? 'fixed' : 'inherit')};
  width: ${props => (props.isFullScreen ? '100vw' : '100%')};
  height: ${props => (props.isFullScreen ? '100vh' : 'inherit')};
  padding-top: ${props => (props.hasPaddingTop ? 100 : 0)}px;
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
`;

const LoaderWrapper = styled.div`
  position: relative;
  width: 100px;
  z-index: 701;
  opacity: 1;
  margin: auto;
  &:before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`;

const wink = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

const color = (props) => keyframes`
  100%,
  0% {
    stroke: ${props.theme.carvana.blue.medium};
  }
  40% {
    stroke: ${props.theme.carvana.blue.dark};
  }
  66% {
    stroke: ${props.theme.carvana.blue.primary};
  }
  80%,
  90% {
    stroke: #f1a426;
  }
`;

const CarIcon = styled.svg`
  width: ${props => (props.isLarge ? 29 : 22)}px;
  height: ${props => (props.isLarge ? 29 : 22)}px;
  color: ${props => props.theme.carvana.blue.medium};
  fill: ${props => props.theme.carvana.blue.medium};
  position: absolute;
  top: ${props => (props.isLarge ? 35 : 39)}%;
  left: ${props => (props.isLarge ? 35 : 39)}%;
  animation: ${wink} 1.25s ease-in-out infinite alternate;
  z-index: 701;
`;

const AnimatedCircle = styled.svg`
  width: ${props => (props.isLarge ? 100 : 70)}%;
  height: ${props => (props.isLarge ? 100 : 70)}%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  animation: ${rotate} 2s linear infinite;
  z-index: 701;
  & > circle {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: ${dash} 1.5s ease-in-out infinite,
      ${props => color(props)} 6s ease-in-out infinite;
    stroke-linecap: round;
  }
`;

const ballClipRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const AnimatedCircleIEFallback = styled.div`
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    width: ${props => (props.isLarge ? 100 : 70)}px;
    height: ${props => (props.isLarge ? 100 : 70)}px;
    color: ${props => props.theme.carvana.blue.primary};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    &:after {
      content: '';
      width: 100%;
      height: 100%;
      display: inline-block;
      border: 2px solid ${props => props.theme.carvana.blue.primary};
      border-bottom-color: transparent;
      border-radius: 50%;
      background: transparent;
      animation: ${ballClipRotate} 0.75s linear infinite;
    }
  }
`;

export {
  Wrapper,
  LoaderWrapper,
  CarIcon,
  AnimatedCircle,
  AnimatedCircleIEFallback
};